const Policy = () => import( /* webpackChunkName: "legal" */ './Policy'),
  Terms = () => import( /* webpackChunkName: "legal" */ './Terms'),
  PrivacyPolicy = () => import( /* webpackChunkName: "legal" */ './PrivacyPolicy'),
  CopyrightPolicy = () => import( /* webpackChunkName: "legal" */ './CopyrightPolicy'),
  ReturnPolicy = () => import( /* webpackChunkName: "returns" */ './ReturnPolicy');

export default {
  path: '/policy',
  redirect: '/',
  component: Policy,
  children: [{
    path: '/terms',
    name: 'terms',
    component: Terms,
  }, {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicy,
  }, {
    path: '/copyright',
    name: 'copyright',
    component: CopyrightPolicy,
  }, {
    path: '/returns',
    name: 'returns',
    component: ReturnPolicy,
  }],
};